// extracted by mini-css-extract-plugin
export var anchor = "AutolinkHeader-module--anchor--2in63";
export var bxTextTruncateEnd = "AutolinkHeader-module--bx--text-truncate--end--11fUD";
export var bxTextTruncateFront = "AutolinkHeader-module--bx--text-truncate--front--16aqS";
export var header = "AutolinkHeader-module--header--3G5Pw";
export var leftAnchor = "AutolinkHeader-module--left-anchor--151ty";
export var rightAnchor = "AutolinkHeader-module--right-anchor--1bmAV";